import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {DeviceDefectWorkflowService} from "./device-defect-workflow.service";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {DeviceDefectModel} from "../../device-defect/device-defect.model";

export interface DefectSetupInputModel {
  deviceDefectId?: string;
  defectOrderName?: string;
  defectDeploymentName?: string;
}

@Component({
  templateUrl: "./setup-defect-dialog.template.pug",
  providers: [
    DeviceDefectWorkflowService,
  ],
})

export class SetupDefectDialogComponent
  extends DialogComponent<DefectSetupInputModel, DeviceDefectModel>
  implements DefectSetupInputModel {
  error: Error;
  defectOrderName: string = "";
  defectDeploymentName: string = "";
  deviceDefectId: string;

  static showCreateDialog(dialogService: DialogService, input: DefectSetupInputModel): Promise<DeviceDefectModel> {
    return dialogService.showDialog(SetupDefectDialogComponent, input);
  }

  constructor(
    private deviceDefectWorkflowService: DeviceDefectWorkflowService,
    public route: ActivatedRoute,
    public router: Router,
    public dialogService: DialogService,
  ) {
    super(dialogService);
    this.result = undefined;
  }

  @handleErrors()
  async setup(): Promise<void> {
    if (!this.defectOrderName && !this.defectDeploymentName) {
      throw new Error("Please supply an order name and a deployment name.");
    }

    this.result = await this.deviceDefectWorkflowService.finalize(
      this.deviceDefectId,
      this.defectOrderName,
      this.defectDeploymentName,
    );

    this.close();
  }

  cancel(): void {
    this.close();
  }
}
